import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({
  children,
  delay = 0,
  y = 30,
  className = "",
  amount = 0.15,
}) => {
  const reduced = useReducedMotion();
  return <motion.div
    className={className}
    initial={reduced ? false : { opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration: reduced ? 0 : 0.65, delay: reduced ? 0 : delay, ease: EASE }}
  >
    {children}
  </motion.div>;
};

export const Stagger = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.12 }}
    variants={{
      hidden: {},
      show: { transition: { staggerChildren: 0.09, delayChildren: delay } },
    }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 26 }) => (
  <motion.div
    className={className}
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.85, ease: EASE } },
    }}
  >
    {children}
  </motion.div>
);

/* Masked line-by-line reveal — the signature on-load moment */
export const MaskedLines = ({
  lines = [],
  className = "",
  delay = 0,
  stagger = 0.13,
  mode = "load",
}) => {
  if (mode === "load") {
    return (
      <span className={className}>
        {lines.map((l, i) => (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em] break-words">
            <motion.span
              className="block will-change-transform"
              initial={{ y: "112%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 1.05, delay: delay + i * stagger, ease: EASE }}
            >
              {l}
            </motion.span>
          </span>
        ))}
      </span>
    );
  }
  return (
    <span className={className}>
      {lines.map((l, i) => (
        <motion.span
          key={i}
          className="block overflow-hidden pb-[0.08em] -mb-[0.08em] break-words"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.span
            className="block will-change-transform"
            variants={{
              hidden: { y: "112%" },
              show: {
                y: "0%",
                transition: { duration: 1.05, delay: delay + i * stagger, ease: EASE },
              },
            }}
          >
            {l}
          </motion.span>
        </motion.span>
      ))}
    </span>
  );
};
